import React, { useContext, useState } from "react";
import { FaPen, FaEllipsisV, FaArrowLeft } from "react-icons/fa";
import { ProfileSection } from "../../context/ProfileContext";
import { useSelector } from "react-redux";
import { ModalComp } from "../";
import { EditDevice } from "./";
import { useTranslation } from "react-i18next";
import { FiInfo, FiCalendar, FiHash, FiTag, FiGrid } from "react-icons/fi";

const DeviceInfo = () => {
  const { t } = useTranslation();
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const selectedDeviceMine = useSelector((state) => state.selectedDeviceMine);
  const [openEditModal, setOpenEditModal] = useState(false);
  const toggleEdit = () => setOpenEditModal(!openEditModal);
  const [device, setDevice] = useState();

  const editDevice = (val) => {
    setDevice(val);
    toggleEdit();
  };

  return (
    <>
      <ModalComp
        modal={openEditModal}
        toggle={toggleEdit}
        component={<EditDevice device={device} toggleEdit={toggleEdit} />}
      />
      
      <div className="setting-container" style={{ minHeight: "90vh" }}>
        <h2 className="setting-title">{t("اطلاعات دستگاه")}</h2>

        {/* Device Image */}
        <div className="device-image-container">
          <img
            src={selectedDeviceMine.category.image}
            className="device-image"
            alt="device"
          />
        </div>

        {/* Device Name with Edit */}
        <div className="device-info-item">
          <div className="device-info-label">
            <FiTag size={16} />
            <span>{t("نام دستگاه")}</span>
          </div>
          <div className="device-info-value">
            <span>{selectedDeviceMine.caption}</span>
            <button
              onClick={() => editDevice(selectedDeviceMine)}
              className="edit-device-btn"
              title={t("ویرایش نام دستگاه")}
            >
              <FaPen size={14} />
            </button>
          </div>
        </div>

        {/* Device Details Grid */}
        <div className="device-details-grid">
          <div className="device-info-item">
            <div className="device-info-label">
              <FiTag size={16} />
              <span>{t("نام شرکتی دستگاه")}</span>
            </div>
            <div className="device-info-value">
              {selectedDeviceMine.category.mark || "---"}
            </div>
          </div>

          <div className="device-info-item">
            <div className="device-info-label">
              <FiGrid size={16} />
              <span>{t("دسته بندی دستگاه")}</span>
            </div>
            <div className="device-info-value">
              {selectedDeviceMine.category.description || "---"}
            </div>
          </div>

          <div className="device-info-item">
            <div className="device-info-label">
              <FiHash size={16} />
              <span>{t("سریال دستگاه")}</span>
            </div>
            <div className="device-info-value device-serial-value">
              {selectedDeviceMine.serial}
            </div>
          </div>

          <div className="device-info-item">
            <div className="device-info-label">
              <FiGrid size={16} />
              <span>{t("تعداد ویجت افزوده شده")}</span>
            </div>
            <div className="device-info-value">---</div>
          </div>

          <div className="device-info-item">
            <div className="device-info-label">
              <FiCalendar size={16} />
              <span>{t("تاریخ افزودن دستگاه به داشبورد")}</span>
            </div>
            <div className="device-info-value">---</div>
          </div>

          <div className="device-info-item">
            <div className="device-info-label">
              <FiInfo size={16} />
              <span>{t("توضیحات دستگاه")}</span>
            </div>
            <div className="device-info-value">
              {selectedDeviceMine.category.description}
            </div>
          </div>
        </div>

        {/* More Info Button */}
        <div className="more-info-btn">
          <span>{t("اطلاعات بیشتر")}</span>
        </div>
        <p className="more-info-text">
          {t("برای مشاهده اطلاعات بیشتر به صفحه محصول در سایت مراجعه نمایید")}
        </p>

        {/* Widgets Section */}
        <div className="widgets-section">
          <div className="widgets-header">
            <h3 className="tickets-title">{t("ویجت های دستگاه")}</h3>
            <span className="widgets-count">6 {t("ویجت")}</span>
          </div>
          
          <div className="widgets-list">
            <div className="widget-item">
              <div className="widget-info">
                <div className="widget-icon"></div>
                <div>
                  <p className="widget-name">{t("ویجت خاموش و روشن")}</p>
                  <p className="widget-original-name">{t("اسم اصلی ویجت")}</p>
                </div>
              </div>
              <FaEllipsisV className="widget-menu-icon" />
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div className="setting-buttons">
          <button
            type="button"
            className="setting-back-btn"
            onClick={() => ProfileShowHideFunc("deviceMine")}
            style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
          >
            <FaArrowLeft size={18} />
            <span>{t("بازگشت")}</span>
          </button>
        </div>
      </div>
    </>
  );
};

export { DeviceInfo };